import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    modalContainer: {
        justifyContent: "center",
        alignItems: "center",
        flex: 1
    },
    modalContent: {
        width: "100%",
        maxWidth: 400
    },
    fullWidth: {
        width: "100%"
    },
    infoText: {},
    infoCard: {}
});
export default stylesheet;
